//import './assets/main.css'
//console.log(window.location.protocol + '//api.' + window.location.host)
import { createApp } from 'vue'
import App from './App.vue'
import { createRouter } from './router'
import { createStore } from './store/store'
import Toasted from '@hoppscotch/vue-toasted'
import * as Sentry from '@sentry/vue'
import '@vuepic/vue-datepicker/dist/main.css' //datepicker
import { websocket } from './websocket'
import SmoothReflow from './components/SmoothReflow.vue'

import '@hoppscotch/vue-toasted/style.css'
import infiniteScroll from 'vue3-infinite-scroll-good'
import { getTerms, orgTerms } from './terminology'

//You should set VITE_API_URL IN PRODUCTION
let url = import.meta.env.VITE_API_URL
if (url === '') {
  url = window.location.protocol + '//api.' + window.location.host
}

const app = createApp(App)
app.config.globalProperties.$apiURL = url

app.use(infiniteScroll)

app.use(Toasted, { className: 'toastedNotification' })
app.component('SmoothReflow', SmoothReflow)

getTerms().then(() => {
  const router = createRouter(app)
  const store = createStore(app)

  if (import.meta.env.VITE_MODE === 'production') {
    Sentry.init({
      app,
      dsn: 'https://0a7c14556f2d4e159c48fdb599c71f11@o4505242880835584.ingest.sentry.io/4505243970109440',
      tunnel: url + '/sentry',
      integrations: [
        Sentry.browserTracingIntegration({ router }),
        Sentry.replayIntegration({
          // Additional SDK configuration goes in here, for example:
          maskAllText: false,
          blockAllMedia: true,
        }),
      ],
      // Performance Monitoring
      tracesSampleRate: 0.2, // Capture 100% of the transactions, reduce in production!
      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    })
  }

  app.use(router)
  app.use(store)

  window.vue = app.mount('#app')

  websocket.init()
})
